/* eslint-disable no-param-reassign */
/**
 * @desc native 通信 bridge
 * @date 2020-01-02
 * */

declare global {
  interface Window {
    jsBridge: any;
    jsbHandler: any;
    YixinJSBridge: any;
  }
}

window.jsBridge = window.jsBridge || {};
window.jsbHandler = window.jsbHandler || {};

let i = 5; // todo 待优化

function transToString(obj: any) {
  if (obj && typeof obj === 'object') {
    Object.keys(obj).forEach((key) => {
      obj[key] = (obj && typeof obj[key] === 'object')
        ? transToString(obj[key])
        : String(obj[key]);
    });
  }
  return obj;
}
class JSBridgeUtil {
  static instance: JSBridgeUtil;

  constructor() {
    if (!JSBridgeUtil.instance) {
      window.jsBridge = this;
      JSBridgeUtil.instance = this;
    }
    return JSBridgeUtil.instance;
  }

  isReady() {
    console.log('isReady this', this);
    return window.YixinJSBridge && window.YixinJSBridge.call && window.YixinJSBridge.invoke;
  }

  ready(cb: () => void) {
    if (i > 1000) {
      console.warn('jsb is still not ready at 1s ago');
      return;
    }
    if (this.isReady()) {
      cb();
    } else {
      setTimeout(() => {
        this.ready(cb);
      }, i *= 2);
    }
  }

  initHandler(that: any) { // todo 待去掉any
    window.jsbHandler = this.jsbHandler.bind(that);
  }

  jsbHandler(method: string, params: any) { // todo 待去掉any
    console.log(method, params);
    (this as any)[method](params); // todo 待去掉any
  }

  call(method: string, params: any) { // todo 待去掉any
    if (method === 'ga4') { // ga埋点，需要把每个字段转化成字符串
      params = transToString(params);
    }

    console.log(`JSBRIDGE_METHOD_CALL\t${method}`, params);

    if (!this.isReady()) {
      console.warn('jsBridge is not ready');
      return;
    }

    window.YixinJSBridge.call(method, params);
  }

  // todo 待去掉any
  invoke(method: string, params: any, onSuccess: (res: any) => void, onError: (res: any) => void) {
    console.log(`JSBRIDGE_METHOD_INVOKE\t${method}`, params);

    if (!this.isReady()) {
      console.warn('jsBridge is not ready');
      return;
    }
    window.YixinJSBridge.invoke(method, params, onSuccess, onError);
  }

  // 打开webView
  openWebView(url: string) {
    this.call('openWebView', url);
  }

  /**
   *  分享朋友圈
   * @param {object} params 参数对象
   * @param {string} params.title 标题
   * @param {string} params.pic   图片src
   * @param {string} params.description 描述文字
   * @param {string} params.url 链接地址
   * @param {string} params.shareType 分享类型：0 聊天室，1 朋友圈
   * @param {object} onSuccess 成功回调
   * @param {object} onError 失败回调
   * @return {void}
   * */
  shareWechat(params: any, onSuccess: () => void, onError: () => void) { // todo 待去掉any
    const config = {
      shareTitle: params.title,
      shareImage: params.image,
      shareDesc: params.desc,
      shareUrl: params.url,
      shareType: params.shareType,
    };

    this.invoke('shareWechat', config, onSuccess, onError);
  }

  /**
   *  保存图片到本地
   * @param {object} img 图片地址
   * @return {void}
   * */
  saveImg(img: string) {
    this.call('saveImg', {
      imgUrl: img,
    });
  }

  /**
   *  设备上是否有安装微信
   * @param {object} onSuccess 成功回调
   * @param {object} onError 失败回调
   * @return {void}
   * */
  hasWx(onSuccess: (res: any) => void, onError: (res: any) => void) {
    this.invoke('hasWx', {}, onSuccess, onError);
  }

  /**
   *  设备上是否有安装支付宝
   * @param {object} onSuccess 成功回调
   * @param {object} onError 失败回调
   * @return {void}
   * */
  hasAlipay(onSuccess: (res: any) => void, onError: (res: any) => void) {
    this.invoke('hasAlipay', {}, onSuccess, onError);
  }

  /**
   *  打开小程序
   * @param {string} path 小程序页面path
   * @return {void}
   * */
  launchWechatMiniProgram(path: string) {
    this.call('launchWechatMiniProgram', {
      path,
    });
  }
}

export default JSBridgeUtil;
